<template>
    <div class="com-partm3">
        <MyTitle title="告警列表" />
        <div class="p-content flex align-center flex-wrap">
            <div
                v-for="(item, i) in list"
                :key="'list' + i"
                class="item flex1 flex justify-center align-center flex-direction">
                <dv-digital-flop style="height: 30px; width: 100%" :config="dvDigitalFlopConfig(item)" />
                <img class="item-c" :src="item.icon" alt="">
                <div class="item-l mt-10">{{ item.label }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import MyTitle from './myTitle1.vue'
import { dataInterface } from "@/api/dataInterfaceApi"
export default {
    components: {
        MyTitle
    },
    data() {
        return {
            colors: [ '#D11818', '#E5750D', '#FFC700' ],
            icons: [
                require('@/assets/images/computility/monitor-icon14.png'),
                require('@/assets/images/computility/monitor-icon15.png'),
                require('@/assets/images/computility/monitor-icon16.png'),
            ],
            list: []
        }
    },
	mounted() {
        // 获取数据
        this.getData()
    },
	methods: {
        // 字体动态
        dvDigitalFlopConfig(item = {}) {
            let counts = parseFloat(item.value || 0)
            let config = {
                number: [parseFloat(counts)],
                textAlign: item.textAlign || 'center',
                style: {
                    fill: item.color || '#fff',
                    fontSize: item.fontSize || 36,
					fontFamily: 'DS-Digital-Bold'
                }
            }
            console.log('==config==', config)
            return config
        },
        // 获取数据
        getData() {
            // let that = this
            let params = { 
                enCode: 'computingpower-left-shishigaojing',
            }
            dataInterface.dataFaceApi(params).then(res => {
                console.log('告警======', res)
                let data = res || []
                this.list = data.map((item, i) => {
                    return {
                        label: item.alarm_level,
                        value: item.alarmNum,
                        color: this.colors[i],
                        icon: this.icons[i],
                    }
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.com-partm3 {
    width: 100%;
    .p-content {
        width: 100%;
        height: calc(100% - $TitleHeight);
        .item {
            width: 33%;
            font-size: $FontSize20;
            position: relative;
            .item-c {
                // position: absolute;
                width: 80px;
                height: 90px;
                // top: 50%;
                // left: 0;
                // transform: translate(0, -50%);
            }
            .item-l {
                font-size: $FontSize28;
            }
        }
    }
}
</style>